import { render, staticRenderFns } from "./ProtectPrinciple.vue?vue&type=template&id=6c67672d&scoped=true&"
import script from "./ProtectPrinciple.vue?vue&type=script&lang=js&"
export * from "./ProtectPrinciple.vue?vue&type=script&lang=js&"
import style0 from "./ProtectPrinciple.vue?vue&type=style&index=0&id=6c67672d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c67672d",
  null
  
)

export default component.exports